export class UpdateFindingExclusionResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "findingExclusion",
            "baseName": "findingExclusion",
            "type": "FindingExclusion",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateFindingExclusionResponse.attributeTypeMap;
    }
    constructor() {
    }
}
